<template>
  <div
    key="new_label"
    :class="{
      'drawer__add-item': !isBeingEdited,
      'drawer__list-item is-editing': isBeingEdited,
      'is-loading': isLoading
    }"
    @click="!isBeingEdited && startEditing()"
  >
    <transition name="switch" appear mode="out-in" @after-enter="focusInput()">
      <!-- Add Button -->
      <div
        v-if="!isBeingEdited"
        key="new_label_inside"
        class="flex items-center gap-2 w-full"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
        <span>{{ $t('Add new label') }}</span>
      </div>

      <!-- Edit Form -->
      <div class="drawer__form w-full" key="new_label_form" v-else>
        <div class="drawer__form-row">
          <input
            type="text"
            class="input flex-1"
            v-model="newName"
            @keydown.enter.prevent="handleSave()"
            :placeholder="$t('Label name')"
            ref="input"
          />

          <swatch-color-picker
            v-model="newColor"
            dropdown-position="right"
          />
        </div>

        <div class="drawer__form-actions justify-end">
          <button
            type="button"
            class="text-sm text-neutral-600 hover:text-neutral-800 font-medium"
            @click.stop="handleClose()"
          >
            {{ $t('Cancel') }}
          </button>
          <button
            type="button"
            class="btn-main text-sm px-3 py-1.5"
            @click.stop="handleSave()"
          >
            {{ $t('Save') }}
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import SwatchColorPicker from "../../components/swatch-color-picker.vue";

export default {
  props: [],
  data: function() {
    return {
      isBeingEdited: false,
      isLoading: false,
      newName: "",
      newColor: "#2D80FA"
    };
  },

  components: {
    SwatchColorPicker
  },

  methods: {
    startEditing(e) {
      this.isBeingEdited = true;
    },

    focusInput() {
      if (this.isBeingEdited) {
        this.$nextTick(() => {
          this.$refs.input.focus();
        });
      }
    },

    handleClose() {
      this.isBeingEdited = false;
      this.newName = "";
      this.newColor = "#828282";
    },

    handleSave() {
      this.createNewLabel();
    },

    createNewLabel() {
      this.isLoading = true;
      let params = new FormData();

      params.append("label[name]", this.newName);
      params.append("label[color]", this.newColor);

      Rails.ajax({
        url: "/updates/labels",
        type: "POST",
        data: params,
        dataType: "json",
        beforeSend: function() {
          return true;
        },
        success: data => {
          this.handleClose();
          this.$emit("newLabel", data);
          this.isLoading = false;
        },
        error: (data, status) => {
          console.log(data);
          this.isLoading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.switch-enter,
.switch-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.switch-enter-to,
.switch-leave {
  opacity: 1;
  transform: translateY(0);
}

.switch-enter-active,
.switch-leave-active {
  transition: opacity 150ms ease, transform 150ms ease;
}
</style>
